import { Button, ButtonProps } from "@mui/material";
import { useTablePreviewFlag } from "~/hooks/useTablePreviewFlag";
import rumClient, { trackEvent } from "~/utils/monitoring";

interface PreviewButtonProps {
  onOpenPreview: () => void;
  analyticsContext?: {
    dataset_id?: string;
    table_fqn?: string;
  };
  size?: ButtonProps["size"];
}

export function PreviewButton({ onOpenPreview, analyticsContext, size }: PreviewButtonProps) {
  const showTablePreview = useTablePreviewFlag();

  if (!showTablePreview) {
    return null;
  }

  const handleClick = () => {
    if (analyticsContext) {
      trackEvent("dataset_table_preview_clicked", analyticsContext);
    }
    onOpenPreview();
  };

  return (
    <Button variant="outlined" size={size} onClick={handleClick} data-testid="view-data-button">
      View Data
    </Button>
  );
}
